import React, { useRef } from "react";
import {
  StyleSheet,
  View,
  TextInput,
  TextInputProps,
  Text,
  TouchableWithoutFeedback,
} from "react-native";
import { colors } from "src/assets";
import { useController } from "react-hook-form";
// import {EventRegister} from 'react-native-event-listeners';
// import {HideKeyboardEvent} from 'utils/event';

export type InputProps = {
  name?: string;
  label?: string;
  helper?: string;
  control?: any;
  defaultValue?: string;
  error?: string;
  variant?: "default" | "search";
} & TextInputProps;

const FormInput: React.FC<InputProps> = ({
  variant,
  label,
  helper,
  name,
  control,
  defaultValue,
  error,
  ...props
}) => {
  const { field } = useController({
    control,
    defaultValue,
    name: name || "input",
  });
  const textInputRef = useRef<TextInput>(null);
  let localStyles: any = styles;
  if (variant === "search") {
    localStyles = searchStyles;
  }
  // const textInputRef = createRef<TextInput>();
  // useEffect(() => {
  //   EventRegister.addEventListener(HideKeyboardEvent, () => {
  //     textInputRef.current?.blur();
  //   });
  //   // TODO: Add remove to event
  // }, [textInputRef]);
  return (
    <TouchableWithoutFeedback onPress={() => textInputRef.current?.focus()}>
      <View style={localStyles.container}>
        <View style={styles.row}>
          {(label || helper) && (
            <View style={{ flexDirection: "column" }}>
              {label ? <Text style={styles.label}>{label}</Text> : null}
              {helper ? <Text style={styles.helper}>{helper}</Text> : null}
            </View>
          )}

          <TextInput
            ref={textInputRef}
            placeholderTextColor={colors.chokuGray}
            style={[
              localStyles.textInput,
              label ? styles.textInputAlignToRight : {},
            ]}
            value={field.value}
            onBlur={field.onBlur}
            onChangeText={field.onChange}
            {...props}
          />
        </View>
        {error ? <Text style={localStyles.error}>{error}</Text> : null}
      </View>
    </TouchableWithoutFeedback>
  );
};

const SimpleInput: React.FC<InputProps> = ({
  variant,
  label,
  helper,
  error,
  ...props
}) => {
  const textInputRef = useRef<TextInput>(null);
  let localStyles: any = styles;
  if (variant === "search") {
    localStyles = searchStyles;
  }
  return (
    <TouchableWithoutFeedback onPress={() => textInputRef.current?.focus()}>
      <View style={localStyles.container}>
        <View style={styles.row}>
          {(label || helper) && (
            <View style={{ flexDirection: "column" }}>
              {label ? <Text style={styles.label}>{label}</Text> : null}
              {helper ? <Text style={styles.helper}>{helper}</Text> : null}
            </View>
          )}

          <TextInput
            ref={textInputRef}
            placeholderTextColor={colors.chokuGray}
            style={[
              localStyles.textInput,
              label ? styles.textInputAlignToRight : {},
            ]}
            {...props}
          />
        </View>
        {error ? <Text style={localStyles.error}>{error}</Text> : null}
      </View>
    </TouchableWithoutFeedback>
  );
};

export const Input: React.FC<InputProps> = ({ control, ...props }) => {
  if (control) {
    return <FormInput control={control} {...props} />;
  }
  return <SimpleInput {...props} />;
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    flexDirection: "column",
    padding: 16,
    borderBottomWidth: 0.5,
    borderBottomColor: colors.gray1,
  },
  row: {
    flexDirection: "row",
  },
  label: {
    color: colors.chokuGray,
    fontSize: 14,
    margin: 0,
    padding: 0,
  },
  helper: {
    color: colors.chokuGray,
    fontSize: 10,
    margin: 0,
    padding: 0,
  },
  textInput: {
    flex: 1,
    color: colors.chokuBlack,
    fontSize: 14,
    margin: 0,
    padding: 0,
    outlineStyle: "none",
  },
  textInputAlignToRight: {
    flex: 1,
    textAlign: "right",
  },
  error: {
    color: colors.chokuRed,
  },
});

const searchStyles = StyleSheet.create({
  container: {
    backgroundColor: colors.chokuGray4,
    flexDirection: "column",
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 14,
  },
  textInput: {
    color: colors.chokuBlack,
    fontSize: 14,
    margin: 0,
    padding: 0,
    outlineStyle: "none",
  },
  error: {
    color: colors.chokuRed,
  },
});
